"use client"

import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Navbar from "./Components/Navbar/Navbar"
import Footer from "./Components/Footer/Footr.jsx"
import Hero from "./Components/Hero/hero.jsx"
import HeroSection from "./Components/Hero Section/HeroSection.jsx"
import StudentChpater from "./Pages/StudentChapter.jsx"
import Department from "./Pages/Department.jsx"
import Events from "./Pages/Events.jsx"
import EventReadMore from "./Pages/EventReadMore.jsx"
import ContactUs from "./Pages/ContactUs.jsx"
import AboutIIChE from "./Pages/AboutIIChE.jsx"
import AOS from "aos"
import "aos/dist/aos.css"
import Program from "./Pages/Program.jsx"
import Technical from "./Pages/Technical.jsx"
import Editorial from "./Pages/Editorial.jsx"
import GraphicsandDesign from "./Pages/GraphicsandDesign.jsx"
import Publicity from "./Pages/Pubilicity.jsx"
import EC2024 from "./Pages/EC2024.jsx"
import AlumniandIndustryConnectCommitte from "./Pages/AluminiandIndustryConnect.jsx"
import SocialandEnvironmnetalCommitte from "./Pages/SocialandEnvironmental.jsx"
import PublicRelations from "./Pages/PublicRelations.jsx"
import EC2023 from "./Pages/EC2023.jsx"
import EC2025 from "./Pages/EC2025.jsx"
import Signin from "./Pages/Signin.jsx"
import SignUpForm from "./Pages/SignUpForm.jsx"
import AdminUpdateForm from "./Pages/AdminUpdateForm.jsx"
import AdminNavbar from "./Pages/AdminNavbar.jsx"
import ImagesPages from "./Pages/ImagesPages.jsx"
import DepartmentUpdate from "./Pages/DepartmentUpdate.jsx"
import ECUpdate from "./Pages/ECUpdate.jsx"
import CommitteUpdateForm from "./Pages/CommitteUpdateForm.jsx"
import EventsUpdate from "./Pages/EventsUpdate.jsx"
import DynamicECDisplay from "./Pages/DynamicECDisplay.jsx"
import ECYearsPage from "./Pages/ECYearsPage.jsx"

const App = () => {
  React.useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 800,
      easing: "ease-in-sine",
      delay: 100,
    })
    AOS.refresh()
  }, [])
  return (
    <>
      <Router>
        <Routes>
          <Route
            index
            element={
              <>
                <Navbar />
                <Hero />
                <HeroSection />
                <Footer />
              </>
            }
          />
          <Route
            path="aboutiiche"
            element={
              <>
                <Navbar />
                <AboutIIChE />
                <Footer />
              </>
            }
          />
          <Route
            path="studentchapter"
            element={
              <>
                <Navbar />
                <StudentChpater />
                <Footer />
              </>
            }
          />
          <Route
            path="department"
            element={
              <>
                <Navbar />
                <Department />
                <Footer />
              </>
            }
          />
          <Route
            path="events"
            element={
              <>
                <Navbar />
                <Events />
                <Footer />
              </>
            }
          />
          <Route
            path="contact"
            element={
              <>
                <Navbar />
                <ContactUs />
                <Footer />
              </>
            }
          />
          <Route
            path="program"
            element={
              <>
                <Navbar />
                <Program />
                <Footer />
              </>
            }
          />
          <Route
            path="editorial"
            element={
              <>
                <Navbar />
                <Editorial />
                <Footer />
              </>
            }
          />
          <Route
            path="technical"
            element={
              <>
                <Navbar />
                <Technical />
                <Footer />
              </>
            }
          />

          <Route
            path="graphicsanddesign"
            element={
              <>
                <Navbar />
                <GraphicsandDesign />
                <Footer />
              </>
            }
          />
          <Route
            path="publicity"
            element={
              <>
                <Navbar />
                <Publicity />
                <Footer />
              </>
            }
          />
          <Route
            path="publicrelations"
            element={
              <>
                <Navbar />
                <PublicRelations />
                <Footer />
              </>
            }
          />
          <Route
            path="aluminiandindustryconnect"
            element={
              <>
                <Navbar />
                <AlumniandIndustryConnectCommitte />
                <Footer />
              </>
            }
          />
          <Route
            path="socialandenvironmental"
            element={
              <>
                <Navbar />
                <SocialandEnvironmnetalCommitte />
                <Footer />
              </>
            }
          />
          <Route
            path="readmore/:id"
            element={
              <>
                <Navbar />
                <EventReadMore />
                <Footer />
              </>
            }
          />

          {/* NEW: EC Years Selection Page */}
          <Route
            path="ec"
            element={
              <>
                <Navbar />
                <ECYearsPage />
                <Footer />
              </>
            }
          />

          {/* Dynamic EC Route for specific year */}
          <Route
            path="ec/:year"
            element={
              <>
                <Navbar />
                <DynamicECDisplay />
                <Footer />
              </>
            }
          />

          {/* Keep existing static EC routes for backward compatibility */}
          <Route
            path="ec2025"
            element={
              <>
                <Navbar />
                <EC2025 />
                <Footer />
              </>
            }
          />
          <Route
            path="ec2024"
            element={
              <>
                <Navbar />
                <EC2024 />
                <Footer />
              </>
            }
          />
          <Route
            path="ec2023"
            element={
              <>
                <Navbar />
                <EC2023 />
                <Footer />
              </>
            }
          />

          <Route
            path="/signin"
            element={
              <>
                <Signin />
                <Footer />
              </>
            }
          />
          <Route
            path="/signup"
            element={
              <>
                <SignUpForm />
                <Footer />
              </>
            }
          />
          <Route
            path="/dashboard"
            element={
              <>
                <AdminNavbar />
                <AdminUpdateForm />
                <Footer />
              </>
            }
          />
          <Route
            path="/admin/images"
            element={
              <>
                <AdminNavbar />
                <ImagesPages />
                <Footer />
              </>
            }
          />
          <Route
            path="/admin/ECupdate"
            element={
              <>
                <AdminNavbar />
                <ECUpdate />
                <Footer />
              </>
            }
          />
          <Route
            path="/admin/department"
            element={
              <>
                <AdminNavbar />
                <DepartmentUpdate />
                <Footer />
              </>
            }
          />
          <Route
            path="/admin/committee"
            element={
              <>
                <AdminNavbar />
                <CommitteUpdateForm />
                <Footer />
              </>
            }
          />
          <Route
            path="/admin/events"
            element={
              <>
                <AdminNavbar />
                <EventsUpdate />
                <Footer />
              </>
            }
          />
        </Routes>
      </Router>
    </>
  )
}

export default App
